import script from "./NotificationItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./NotificationItem.vue?vue&type=script&lang=ts&setup=true"

import "./NotificationItem.vue?vue&type=style&index=0&id=4b60362c&scoped=true&lang=css"
/* custom blocks */
import block0 from "./NotificationItem.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b60362c"]])

export default __exports__